import { enUS } from 'date-fns/locale';

export const formatPhoneNumber = (value: string) => {
  const cleaned = value.replace(/\D/g, ''); // Remove non-numeric characters
  if (cleaned.length <= 3) return cleaned;
  if (cleaned.length <= 6) return `${cleaned.slice(0, 3)} ${cleaned.slice(3)}`;
  return `${cleaned.slice(0, 3)} ${cleaned.slice(3, 6)} ${cleaned.slice(6, 10)}`;
};

const shortTokens: Record<string, string> = {
  lessThanXSeconds: '{{count}}s',
  xSeconds: '{{count}}s',
  halfAMinute: '30s',
  lessThanXMinutes: '{{count}}m',
  xMinutes: '{{count}}m',
  aboutXHours: '{{count}}h',
  xHours: '{{count}}h',
  xDays: '{{count}}d',
  aboutXWeeks: '{{count}}w',
  xWeeks: '{{count}}w',
  aboutXMonths: '{{count}}mo',
  xMonths: '{{count}}mo',
  aboutXYears: '{{count}}y',
  xYears: '{{count}}y',
  overXYears: '{{count}}y',
  almostXYears: '{{count}}y',
};

export const enShort = {
  ...enUS,
  formatDistance(token: string, count: number, opts?: { addSuffix?: boolean; comparison?: number }) {
    let result = shortTokens[token]?.replace('{{count}}', String(count)) ?? '';
    if (opts?.addSuffix) {
      // `comparison` is >0 for future, <0 for past
      result = opts.comparison! > 0 ? `in ${result}` : `${result} ago`;
    }
    return result;
  },
};
